// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SOF_wrapper__22RTz","greenArrow":"SOF_greenArrow__17BmE","contentWrapper":"SOF_contentWrapper__2diZk","formWrapper":"SOF_formWrapper__3Yh54"};